//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWorkOrderById } from '../../../../api/workOrder';
import { getDictionaryItems } from '../../../../api/dictionary';
import { getNodesByName } from '../../../../api/node';
import fileUploader from '@/views/common-components/file-uploader';

export default {
    name: 'info-view',
    components: { fileUploader },
    props: {
        workOrderId: {
            required: true,
            type: Number
        }
    },
    data() {
        return {
            workOrderInfo: {
                severity: [],
                reason: []
            },
            nodes: [],//二级分类
            threeNodes: [],//三级分类
            fourNodes: [],//四级分类
            customerCallList: [],
            customerCallInputDto: {
                content: ''
            },
            showCreateCustomerCall: false,
            savCustomerCallIng: false,
            severities: [],
            reasons: [],
            a: ''
        };
    },
    computed: {
        // workOrderInfo() {
        //     return this.$store.state.workOrder.workOrderInfo;
        // }
    },
    methods: {
        getWorkOrderById() {
            const vm = this;
            this.$store.dispatch({
                type: 'workOrder/getWorkOrderById',
                id: this.workOrderId
            }).then(res => {
                vm.workOrderInfo = {};
                let wk = {};
                wk = JSON.parse(JSON.stringify(vm.$store.state.workOrder.workOrderInfo));

                if (wk.workOrderType === 1) {
                    if (wk.severity && wk.severity !== null) {
                        wk.severity = JSON.parse(wk.severity);
                    } else {
                        wk.severity = [];
                    }
                    if (wk.reason && wk.reason !== null) {
                        wk.reason = JSON.parse(wk.reason);
                    } else {
                        wk.reason = [];
                    }
                }
                this.workOrderInfo = {
                    severity: [],
                    reason: []
                };
                this.workOrderInfo = wk;
                vm.getOthersData();
            }).finally(() => {

            });

            // if (vm.workOrderInfo.severity && vm.workOrderInfo.severity != null) {
            //     vm.workOrderInfo.severity = JSON.parse(vm.workOrderInfo.severity);
            // } else {
            //     vm.workOrderInfo.severity = [];
            // }
            // if (vm.workOrderInfo.reason && vm.workOrderInfo.reason != null) {
            //     vm.workOrderInfo.reason = JSON.parse(vm.workOrderInfo.reason);
            // } else {
            //     vm.workOrderInfo.reason = [];
            // }

            // this.$store.dispatch({
            //     type: 'workOrder/getWorkOrderById',
            //     id: this.workOrderId
            // }).then(res => {
            // let wk = this.workOrderInfo;
            // if (wk.workOrderType === 1) {
            //     if (wk.severity && wk.severity !== null) {
            //         wk.severity = JSON.parse(wk.severity);
            //     } else {
            //         wk.severity = [];
            //     }
            //     if (wk.reason && wk.reason !== null) {
            //         wk.reason = JSON.parse(wk.reason);
            //     } else {
            //         wk.reason = [];
            //     }
            // }
            // this.workOrderInfo = wk;
            // this.getOthersData();
            // });

        },
        onShowCreateCustomerCall() {
            this.customerCallInputDto = {
                content: ''
            };
            this.showCreateCustomerCall = !this.showCreateCustomerCall;
        },

        getOthersData() {
            if (this.workOrderInfo.workOrderType === 1) {
                this.getSeverities();
                this.getReasons();
                this.getNodes('投诉分类');
            } else if (this.workOrderInfo.workOrderType === 2) {
                this.getNodes('报修分类');
            } else if (this.workOrderInfo.workOrderType === 0) {
                this.getNodes('咨询分类');
            }
        },

        /*二级分类*/
        getNodes(name) {
            const vm = this;
            getNodesByName(name).then(res => {
                vm.nodes = [];
                vm.nodes.push(...res.data.result.items[0].children);
                if (parseInt(vm.workOrderInfo.erJiFenLei) > 0) {
                    vm.onSelectNode(vm.workOrderInfo.erJiFenLei);
                }
                vm.$emit('getNodes', vm.nodes);
            }).finally(() => {

            });
        },
        onSelectNode(d) {
            const vm = this;
            let index = vm.nodes.findIndex(x => x.id === d);
            vm.threeNodes = vm.nodes[index].children;
            // vm.startHandleDto.sanJiFenLei = 0;
        },

        getCustomerCallList() {
            const vm = this;
            vm.$store.dispatch({
                type: 'workOrder/getCustomerCallList',
                data: { workOrderId: vm.workOrderId }
            }).then(() => {
                vm.customerCallList = vm.$store.state.workOrder.customerCallList;
            });
        },

        saveCustomerCall() {
            const vm = this;
            vm.customerCallInputDto.workOrderId = vm.workOrderId;
            vm.customerCallInputDto.memberId = vm.workOrderInfo.memberId;
            vm.savCustomerCallIng = true;
            vm.$store.dispatch({
                type: 'workOrder/saveCustomerCall',
                data: vm.customerCallInputDto
            }).then(res => {

                vm.$Notice.success({
                    duration: 3,
                    title: '保存成功'
                });
                vm.showCreateCustomerCall = false;
                vm.getCustomerCallList();
            }).finally(() => {
                vm.savCustomerCallIng = false;
            });
        },

        customerCallDateChange(date) {
            // console.log(date);
            this.customerCallInputDto.createTime = date;
        },

        getSeverities() {
            getDictionaryItems('投诉严重程度分类').then(res => {
                this.severities = [];
                this.severities.push(...res.data.result);
            }).finally(() => {

            });

            // this.$store.dispatch({
            //     type: 'workOrder/getSeverities'
            // }).then(() => {
            //     this.severities = [];
            //     this.severities = this.$store.state.workOrder.severities;
            // });
        },
        getReasons() {
            getDictionaryItems('重复投诉引发原因').then(res => {
                this.reasons = [];
                this.reasons.push(...res.data.result);
            });

            // this.$store.dispatch({
            //     type: 'workOrder/getReasons'
            // }).then(res => {
            //     this.reasons = [];
            //     this.reasons = this.$store.state.workOrder.reasons;
            // }).finally(() => {
            // });
        }
    },
    created() {
        if (this.workOrderId > 0) {
            this.getWorkOrderById();
            this.getCustomerCallList();
        }
    },

    watch: {
        workOrderId(val, oldValue) {
            this.getWorkOrderById();
            this.getCustomerCallList();
        }
    }
};
